import { render, staticRenderFns } from "./RemoveStockNext.vue?vue&type=template&id=d5139f64&scoped=true"
import script from "./RemoveStockNext.vue?vue&type=script&lang=js"
export * from "./RemoveStockNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5139f64",
  null
  
)

export default component.exports